import React from 'react'
import _ from 'lodash'
import SolutionRow from '../../components/SolutionRow'
import TytoFlowchart from '../../components/TytoFlowchart'
import StudentQualityList from '../../components/StudentQualityList'
import '../../assets/css/pages/track_progress/flowchart-submissions.css'

const FlowchartSubmissions = props => {
  const { description, flowcharts } = props

  const getTextFor = flowchart => {
    const percentageText = `${Math.round(flowchart.percentage * 100)}%`
    return `${percentageText} of this group of students submitted this ${flowchart.isCorrect ? 'correct' : 'incorrect'} answer`
  }

  return(
    <div className='flowchart-submissions'>
      <p className='task'>
        <span>TASK: </span>
        <span>{description}</span>
      </p>
      {_.map(flowcharts, flowchart =>
        <div key={JSON.stringify(flowchart)} className='row-wrapper'>
          <div className='flowchart-wrapper'>
            <SolutionRow type={flowchart.isCorrect ? 'correct' : 'incorrect'}>
              <TytoFlowchart nodes={flowchart.nodes} edges={flowchart.edges}/>
            </SolutionRow>
          </div>
          <div className='student-list-wrapper'>
            <StudentQualityList
              text={getTextFor(flowchart)}
              students={flowchart.students}/>
          </div>
        </div>
      )}
    </div>
  )
}

export default FlowchartSubmissions
